import AdminEventTable from "@/components/adminEvent/AdminEventTable";


export default function AdminEvent() {
    return (
        <div className="flex items-center h-full pt-10 flex-col">
            <AdminEventTable/>
        </div>
    );
}